(function(){
var d=document.documentElement;d.classList.add('vg-js');window.__vgOK=1;
function show(e){e.classList.add('is-in')}
function check(){var h=window.innerHeight||d.clientHeight;document.querySelectorAll('.vg-rv:not(.is-in)').forEach(function(e){if(e.getBoundingClientRect().top<h*0.96)show(e)})}
function reveal(){
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){show(x.target);io.unobserve(x.target)}})},{rootMargin:'0px 0px -4% 0px'});
    document.querySelectorAll('.vg-rv:not(.is-in)').forEach(function(e){io.observe(e)});
  }
  var t=0;window.addEventListener('scroll',function(){if(t)return;t=setTimeout(function(){t=0;check()},120)},{passive:true});
  window.addEventListener('resize',check);
  check();setTimeout(check,600);
}
function sticky(){var bar=document.querySelector('.vg-sticky');if(!bar)return;var t=document.querySelector('.product-form__submit');var go=bar.querySelector('[data-vg-go]');if(go){go.addEventListener('click',function(ev){var o=document.querySelector('.vg-offer')||document.querySelector('.product__info-container');if(o){ev.preventDefault();o.scrollIntoView({behavior:'smooth',block:'start'})}})}
  if(!t)return;
  function upd(){var r=t.getBoundingClientRect();bar.classList.toggle('is-on',r.bottom<0)}
  window.addEventListener('scroll',upd,{passive:true});upd();
}
function run(){reveal();sticky()}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
